<template>
  <div aria-live="assertive">
    <template v-for="(curServiceData, index) in props.serviceData">
      <template v-if="curServiceData.status == 'fulfilled'">
        <div v-if="$slots.success" :key="'success-' + index" class="vm-mb-4">
          <slot name="success" v-bind="getSlotProps(curServiceData, index)" />
        </div>
      </template>
      <div v-else :key="'error-' + index" class="vm-mb-4">
        <slot
          v-if="$slots.error"
          name="error"
          v-bind="getSlotProps(curServiceData, index)"
        />
        <ServiceErrorAlert
          v-else
          :cur-service-data="curServiceData"
          :is-last-service="index == lastServiceErrorIndex"
        />
      </div>
    </template>
  </div>
</template>

<script setup>
import { computed } from "vue";
import findLastIndex from "lodash/findLastIndex";

const props = defineProps({
  serviceData: {
    type: Array,
    required: true,
  },
});

function getSlotProps(curServiceData, index) {
  return {
    curServiceData,
    index,
    isLastService: index == lastServiceErrorIndex.value,
  };
}

const lastServiceErrorIndex = computed(() =>
  findLastIndex(props.serviceData, ({ status }) => status == "rejected")
);
</script>
